// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Amiri:ital,wght@0,400;0,700;1,400;1,700','Noto+Sans:ital,wght@0,400,;wght@0,500;wght@0,600;wght@0,700;wght@0,800;1,100..900&display=swap']
    },
    //,
    // typekit: {
    // id: 'XXXX'
    // },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

// Prevent clash with woocommerce
(function ($) {

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');
require('waypoints/lib/jquery.waypoints');

//Load Modules
require('./modules/accordion');
require('./modules/applyNow');
require('./modules/breadcrumb');
require('./modules/filtersSticky');
require('./modules/formInputs');
require('./modules/imageModal');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/menu');
require('./modules/modal');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/statistics');
require('./modules/tabs');
require('./modules/timeline');
require('./modules/languageSwitcher');
require('./modules/slider');
require('./modules/stickyNav');
require('./modules/stickyPageNav');
require('./modules/variableSliderModal');
require('./modules/variableSlider');
require('./modules/woocommerce');

})(jQuery);
// END Prevent clash with woocommerce